import type { Locale } from '@spot/shared';
import type { ReactNode } from 'react';

import { openExternalLink } from '../../lib/telegram';

export type LegalDoc = 'terms' | 'privacy';

/** T-805: static pages in `public/legal/` (public URLs, also usable in BotFather). */
export function legalUrl(doc: LegalDoc, locale: Locale): string {
	const file = locale === 'uk' ? `${doc}.html` : `${doc}-en.html`;
	return new URL(`/legal/${file}`, window.location.origin).href;
}

/** Inline link that opens a legal page without leaving the Mini App. */
export function LegalLink({
	doc,
	locale,
	children,
}: {
	doc: LegalDoc;
	locale: Locale;
	children?: ReactNode;
}) {
	const href = legalUrl(doc, locale);
	return (
		<a
			href={href}
			target="_blank"
			rel="noopener"
			className="text-primary underline"
			onClick={(event) => {
				event.preventDefault();
				openExternalLink(href);
			}}
		>
			{children}
		</a>
	);
}
